function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8e8e8e;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M19.586,5.377l-.531-1.592a1.481,1.481,0,0,0-1.407-1.014H13.184V1.318A1.319,1.319,0,0,0,11.867,0H7.779A1.319,1.319,0,0,0,6.462,1.318V2.771H2A1.481,1.481,0,0,0,.592,3.785L.06,5.377A1.192,1.192,0,0,0,1.191,6.946h.555l1.222,15.11a2.186,2.186,0,0,0,2.166,2H14.76a2.186,2.186,0,0,0,2.166-2l1.222-15.11h.307a1.192,1.192,0,0,0,1.131-1.569ZM7.872,1.41h3.9V2.771h-3.9Zm7.649,20.533a.769.769,0,0,1-.761.7H5.134a.769.769,0,0,1-.761-.7l-1.213-15H16.734ZM1.493,5.536l.436-1.306A.073.073,0,0,1,2,4.18h15.65a.073.073,0,0,1,.07.05l.436,1.306Zm0,0",
  transform: "translate(0.001)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M268.964,179.689H269a.7.7,0,0,0,.7-.668l.662-12.7a.7.7,0,0,0-1.408-.073l-.662,12.7A.7.7,0,0,0,268.964,179.689Zm0,0",
  transform: "translate(-255.69 -157.797)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M106.488,179.026a.7.7,0,0,0,.7.666h.039a.7.7,0,0,0,.665-.742l-.693-12.7a.7.7,0,1,0-1.407.077Zm0,0",
  transform: "translate(-100.823 -157.799)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M194.959,179.692a.7.7,0,0,0,.7-.7v-12.7a.7.7,0,1,0-1.41,0v12.7A.7.7,0,0,0,194.959,179.692Zm0,0",
  transform: "translate(-185.127 -157.799)"
});

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.647,
    height: 24.056,
    viewBox: "0 0 19.647 24.056",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.cb05aa13.svg";
export { ForwardRef as ReactComponent };